var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c(
      "div",
      {
        staticClass: "container-fluid d-flex flex-wrap justify-content-between"
      },
      [
        _c("nav", [
          _c("ul", { staticClass: "footer-menu" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { path: "/admin" } } }, [
                  _vm._v("Dashboard")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _vm._v("\n      © Coded with\n      "),
      _c("i", { staticClass: "fa fa-heart heart" }),
      _vm._v(" by\n      "),
      _c(
        "a",
        { attrs: { href: "https://github.com/cristijora", target: "_blank" } },
        [_vm._v("Cristi Jora")]
      ),
      _vm._v(".\n      Designed by "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.creative-tim.com/?ref=pdf-vuejs",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("Creative Tim")]
      ),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0841f88e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0841f88e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/ContentFooter.vue
// module id = oEjg
// module chunks = 4